module.exports = __webpack_public_path__ + "b8d52ac5c4c7e853cabb5564f3d3e4d0.png";